import type { DemandeRemboursementDTO } from '@/features/api/extranet/dto/Demande/DR'
import type { ErreurSummaryConfiguration } from '@/features/application/erreur-summary'
import Documents from '@/features/interface/demande/dr/steps/documents/DocumentsDossierStep.vue'
import DossierFormation from '@/features/interface/demande/dr/steps/dossierformation/DossierFormationStep.vue'
import ModuleStep from '@/features/interface/demande/dr/steps/modules/ModuleStep.vue'
import SyntheseStep from '@/features/interface/demande/dr/steps/synthese/SyntheseStep.vue'
import type { SetupDemande } from '@/features/interface/demande/shared'
import { provide, type Component } from 'vue'
import { DR_ACTIONS, useDRActions } from './useDRActions'
import { useDossierDRStore } from './useDRStore'

type TabKey =
  | 'Dossier Formation'
  | 'Module 1'
  | 'Module 2'
  | 'Module 3'
  | 'Module 4'
  | 'Module 5'
  | 'Module 6'
  | 'Module 7'
  | 'Module 8'
  | 'Module 9'
  | 'Module 10'
  | 'Synthèse'
  | 'Documents'

const TABS_VUES: Record<TabKey, Component> = {
  'Dossier Formation': DossierFormation,
  'Module 1': ModuleStep,
  'Module 2': ModuleStep,
  'Module 3': ModuleStep,
  'Module 4': ModuleStep,
  'Module 5': ModuleStep,
  'Module 6': ModuleStep,
  'Module 7': ModuleStep,
  'Module 8': ModuleStep,
  'Module 9': ModuleStep,
  'Module 10': ModuleStep,
  Synthèse: SyntheseStep,
  Documents,
} as const

const TABS_ERR_CONFIG: ErreurSummaryConfiguration<DemandeRemboursementDTO> = {
  'Dossier Formation': {
    includeDeep: (state) => [state.mission],
    include: (state) => [state.validationNotice],
  },
  'Module 1': {},
  'Module 2': {},
  'Module 3': {},
  'Module 4': {},
  'Module 5': {},
  'Module 6': {},
  'Module 7': {},
  'Module 8': {},
  'Module 9': {},
  'Module 10': {},
  Synthèse: {},
  Documents: {},
}

export const SetupDossierDR: SetupDemande<'MODEL_DR', TabKey> = {
  useStore: useDossierDRStore,
  injectActions: (store) => {
    const actions = useDRActions(store)
    provide(DR_ACTIONS, actions)
    return actions
  },
  tabFirst: 'Dossier Formation',
  tabsVue: TABS_VUES,
  tabsErrorConfig: (store) => {
    // Dynamise les modules selon le nombre de module de la DR
    const nbModules = store.model?.modules?.length ?? 0
    return Object.entries(TABS_ERR_CONFIG).reduce((tabs, [key, value]) => {
      if (!key.startsWith('Module ')) {
        tabs[key] = value
      } else {
        const numModule = Number(key.split(' ')[1]) - 1
        if (numModule < nbModules) {
          tabs[key] = value
        }
      }
      return tabs
    }, {} as ErreurSummaryConfiguration<DemandeRemboursementDTO>)
  }
} as const
